import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, GoogleAuthProvider, TwitterAuthProvider, signInWithRedirect, getRedirectResult, linkWithRedirect, unlink, signOut, deleteUser } from 'firebase/auth';
import { getFirestore, deleteDoc, addDoc, doc, setDoc, updateDoc, getDoc, collection, getDocs, arrayUnion, Timestamp, increment, query, orderBy, limit, where } from "firebase/firestore";
import { getStorage, ref, uploadString, getDownloadURL } from "firebase/storage";
// https://firebase.google.com/docs/storage/web/upload-files?hl=ja

import store from "@/store";

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDQ32cW_C0Vj7SQre4isUHn1wcWWccK2F4",
  authDomain: "mai-6ec38.firebaseapp.com",
  projectId: "mai-6ec38",
  storageBucket: "mai-6ec38.appspot.com",
  messagingSenderId: "962504040460",
  appId: "1:962504040460:web:92ef90c44942ad2f908e29",
  measurementId: "G-RJR0JW6K9V"
};

// twitter
// key
// R40agVcynkRr9jPbzWUnL80Nq
// secret
// RE8nvd4ihnis5Nd9XQqaCIrWTdw3k5XvFJqauBd1sXwbq9myw8
// token
//AAAAAAAAAAAAAAAAAAAAABlTWQEAAAAAarur8gApW6mgQ3qZGaJGoaIRucQ%3DQRBkQ6vIQ83DX5YfG5cPr9uGEkjuoHG3eVeStV7y2uvVTead4C

initializeApp(firebaseConfig);
const G_provider = new GoogleAuthProvider();
const T_provider = new TwitterAuthProvider();
const auth = getAuth();
const user = auth.currentUser;
const db = getFirestore();
const storage = getStorage();

export default {
  init() {
    return initializeApp(firebaseConfig);
  },
  onAuth(page) {
    return new Promise((resolve) => {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          store.commit('setUser', user);
          resolve();
        } else if (page == 'ranking' || page == 'challenge' || page == 'user') {
          resolve();
        } else {
          location.replace("/ranking");
        }
      });
    });
  },
  User() {
    if (user !== null) {
      user.providerData.forEach((profile) => {
        console.log("Sign-in provider: " + profile.providerId);
        console.log("  Provider-specific UID: " + profile.uid);
        console.log("  Name: " + profile.displayName);
        console.log("  Email: " + profile.email);
        console.log("  Photo URL: " + profile.photoURL);
      });
    }

  },
  G_login() {
    signInWithRedirect(auth, G_provider);
  },
  G_redirect() {
    return new Promise(resolve => {
      getRedirectResult(auth)
        .then((result) => {
          if (result) {
            store.commit('setUser', result.user);
            getDoc(doc(db, "users", `${result.user.uid}`)).then((docData) => {
              if (!docData.data()) {
                setDoc(doc(db, "users", `${result.user.uid}`), {
                  profile: {
                    icon: result.user.photoURL,
                    name: result.user.displayName,
                    textarea: "",
                    challenge: false,
                  },
                  mai: {
                    increment: {
                      given: 0,
                      buy: 0,
                      assign: 100,
                    },
                    decrement: {
                      sent: 0,
                      pay: 0,
                    },
                    total: 100,
                    useable: 100,
                  }
                }).then(() => {
                  this.setNotice(result.user.uid, `${result.user.displayName}さん、登録してくれてありがとう！100maiの使い方はここをタップしてね`, "about", "news").then(() => { resolve() });
                });
              }
            });
          }

          // // This gives you a Google Access Token. You can use it to access Google APIs.
          // const credential = GoogleAuthProvider.credentialFromResult(result);
          // const token = credential.accessToken;

          // // The signed-in user info.
          // const user = result.user;
          // return credential,token,user;
          console.log('G_direct', result);
        }).catch((error) => {
          // // Handle Errors here.
          // const errorCode = error.code;
          // const errorMessage = error.message;
          // // The email of the user's account used.
          // const email = error.email;
          // // The AuthCredential type that was used.
          // const credential = GoogleAuthProvider.credentialFromError(error);
          // console.log(errorCode,errorMessage,email,credential);
          // // ...
          // router.push({name: 'Login'});
          console.log('G_direct', error);
        });
    });
  },
  T_login() {
    signInWithRedirect(auth, T_provider);
  },
  T_redirect() {
    return new Promise(resolve => {
      getRedirectResult(auth)
        .then((result) => {
          if (result) {
            store.commit('setUser', result.user);
            getDoc(doc(db, "users", `${result.user.uid}`)).then((docData) => {
              if (!docData.data()) {
                setDoc(doc(db, "users", `${result.user.uid}`), {
                  profile: {
                    icon: result.user.photoURL,
                    name: result.user.displayName,
                    textarea: "",
                    challenge: false,
                  },
                  mai: {
                    increment: {
                      give: 0,
                      buy: 0,
                      assign: 100,
                    },
                    decrement: {
                      send: 0,
                      pay: 0,
                    },
                    total: 100,
                    useable: 100,
                  }
                }).then(() => {
                  this.setNotice(result.user.uid, `${result.user.displayName}さん、登録してくれてありがとう！100maiの使い方はここをタップしてね`, "about", "news").then(() => { resolve() });
                });
              }
            });
          }
          // // This gives you a the Twitter OAuth 1.0 Access Token and Secret.
          // // You can use these server side with your app's credentials to access the Twitter API.
          // const credential = TwitterAuthProvider.credentialFromResult(result);
          // const token = credential.accessToken;
          // const secret = credential.secret;
          // // ...

          // // The signed-in user info.
          // const user = result.user;
          // return credential,token,secret,user;
          console.log('T_direct', result);
        }).catch((error) => {
          // // Handle Errors here.
          // const errorCode = error.code;
          // const errorMessage = error.message;
          // // The email of the user's account used.
          // const email = error.email;
          // // The AuthCredential type that was used.
          // const credential = TwitterAuthProvider.credentialFromError(error);
          // // ...
          // console.log(errorCode,errorMessage,email,credential);
          // // ...
          // router.push({name: 'Login'});
          console.log('T_direct', error);
        });
    });
  },
  addProvider(provider) {
    if (provider == 'twitter') {
      return new Promise((resolve) => {
        linkWithRedirect(auth.currentUser, T_provider)
          .then(() => {
            resolve();
          })
          .catch(/* ... */);
      });
    } else if (provider == 'google') {
      return new Promise((resolve) => {
        linkWithRedirect(auth.currentUser, G_provider)
          .then(() => {
            resolve();
          })
          .catch(/* ... */);
      });
    }

  },
  unlink(providerId) {
    return new Promise((resolve) => {
      unlink(auth.currentUser, providerId).then(() => {
        // Auth provider unlinked from account
        // ...
        resolve();
      }).catch((error) => {
        // An error happened
        console.log(error);
        // ...
      });
    });
  },
  signOut() {
    return new Promise((resolve) => {
      signOut(auth).then(() => {
        // Sign-out successful.
        resolve();
      }).catch((error) => {
        // An error happened.
        console.log(error);
      });
    });
  },
  deleteUser() {
    deleteUser(user).then(() => {
      // User deleted.
    }).catch((error) => {
      // An error ocurred
      console.log(error);
      // ...
    });
  },

  // 日付変換 /////////////////////////////////////////////////
  displayTime(unixTime) {
    var date = new Date(unixTime);
    var diff = new Date().getTime() - date.getTime();
    var d = new Date(diff);

    if (d.getUTCFullYear() - 1970) {
      return d.getUTCFullYear() - 1970 + "年前";
    } else if (d.getUTCMonth()) {
      return d.getUTCMonth() + "ヶ月前";
    } else if (d.getUTCDate() - 1) {
      return d.getUTCDate() - 1 + "日前";
    } else if (d.getUTCHours()) {
      return d.getUTCHours() + "時間前";
    } else if (d.getUTCMinutes()) {
      return d.getUTCMinutes() + "分前";
    } else {
      return d.getUTCSeconds() + "秒前";
    }
  },
  timeTransfer(unixTime) {
    var date = new Date(unixTime);
    return `${date.getUTCFullYear()}/${date.getUTCMonth() + 1}/${date.getUTCDate()} ${date.getUTCHours()}・${date.getUTCMinutes()}`;
  },

  // profile /////////////////////////////////////////////////////////////
  getUserProfile(uid) {
    return new Promise((resolve) => {
      // icon,name,profileをダウンロード
      const docRef = doc(db, "users", `${uid}`);//リファレンスの作成
      getDoc(docRef).then((doc) => {
        store.commit('setProfile', doc.data().profile);
        // storeに保存
        resolve();
      });
    });
  },
  getOtherProfile(uid) {
    return new Promise((resolve) => {
      const docRef = doc(db, "users", `${uid}`);
      getDoc(docRef).then((doc) => {
        resolve(doc.data().profile);
      });
    });
  },
  setUserProfile(uid, data) {
    return new Promise((resolve) => {
      const docRef = doc(db, "users", `${uid}`);
      updateDoc(docRef, {
        "profile.name": data.name,
        "profile.textarea": data.textarea,
      }, { merge: true }).then(() => {
        if (!data.icon.new) {
          resolve();
        } else {
          let storageRef = ref(storage, `users/${uid}/icon`);
          uploadString(storageRef, data.icon.new, 'data_url').then(() => {
            getDownloadURL(ref(storage, `users/${uid}/icon`)).then((url) => {
              updateDoc(docRef, {
                "profile.icon": url,
              }).then(() => {
                resolve();
              });
            });
          });
        }
      });
    });
  },

  // challenge ////////////////////////////////////////////////////////////////
  setChallenge(uid, data) {
    return new Promise((resolve) => {
      const userRef = doc(db, "users", `${uid}`);
      updateDoc(userRef, {
        "profile.challenge": true,
      }).then(() => {
        const challengeRef = collection(db, "challenges");//リファレンスの作成
        addDoc(challengeRef, {
          album: false,
          created: Timestamp.fromDate(new Date()),
          update: Timestamp.fromDate(new Date()),
          host: uid,
          post: 0,
          mai_support: 0,

          data,
        }).then((docRef) => {
          const docRef2 = doc(db, "users", `${uid}`, "challenges", `${docRef.id}`);
          setDoc(docRef2, {
            id: docRef.id,
          })
          resolve(docRef.id);
        });
      })
    });
  },
  updateChallenge(cid, name, data) {
    return new Promise(resolve => {
      const challengeRef = doc(db, "challenges", `${cid}`);
      updateDoc(challengeRef, {
        name: name,
        data
      }, { marge: true }).then(() => { resolve(); });
    });
  },
  updateAlbum(cid) {
    return new Promise(resolve => {
      const challengeRef = doc(db, "challenges", `${cid}`);
      updateDoc(challengeRef, {
        album: true,
      }, { marge: true }).then(() => { resolve(); });
    })
  },
  deleteChallenge(uid, cid) {
    return Promise.all([
      challenge(cid),
      user(uid, cid),
    ]);
    function challenge(cid) {
      return new Promise(resolve => {
        const challengeRef = collection(db, "challenges", `${cid}`);
        deleteDoc(challengeRef).then(() => { resolve(); });
      });
    }
    function user(uid, cid) {
      return new Promise(resolve => {
        const userRef = doc(db, "users", `${uid}`, "challenges", `${cid}`);
        deleteDoc(userRef).then(() => { resolve(); });
      });
    }
  },
  getChallenge(cid) {
    return new Promise(resolve => {
      const docRef = doc(db, "challenges", `${cid}`);//リファレンスの作成
      getDoc(docRef).then((doc) => {
        resolve(doc.data());
      });
    })
  },
  getChallengesList(uid) {
    //全てのチャレンジを取ってくる
    return new Promise(resolve => {
      let getId = new Promise(resolve => {
        let array = [];
        const idRef = collection(db, "users", `${uid}`, "challenges");
        getDocs(idRef).then((doc) => {
          doc.docs.forEach((item, index, a_doc) => {
            array.push(item.id);
            if (index == a_doc.length - 1) {
              resolve(array);
            }
          })
        });
      });
      getId.then((array) => {
        // https://qiita.com/saka212/items/ff61a6de9c3e19810c5d
        let getList = Promise.resolve();
        let allList = [];
        for (let i = 0; i < array.length; i++) {
          getList = getList.then(getCList.bind(this, array[i], i));
        }
        function getCList(id, i) {
          return new Promise(resolve => {
            const challengeRef = doc(db, "challenges", `${id}`);
            getDoc(challengeRef).then((doc) => {
              if (!doc.data().album && new Date(doc.data().data.span.span.seconds) <= new Date().getTime()) {
                allList.push({
                  id: id,
                  data: doc.data(),
                });
                allList[i].data.album = true;
                this.checkAlbum();
                resolve();
              } else {
                allList.push({
                  id: id,
                  data: doc.data(),
                });
                resolve();
              }
            });
          });
        }
        getList.then(() => {
          store.commit('setAllList', allList);
          resolve();
        });
      }).catch((error) => {
        console.log(error);
      });
    });
  },
  checkAlbum(cid) {
    //チャレンジの期限を確認する
    return new Promise(resolve => {
      const challengeRef = doc(db, "challenges", `${cid}`);
      updateDoc(challengeRef, {
        album: true,
      }).then(() => { resolve(); });
    });
  },
  getChallengeSupporter(cid) {
    // hostのみ支援者一覧を取得
    return new Promise((resolve) => {
      let getId = new Promise((resolve) => {
        let array = [];
        const supporterRef = collection(db, "challenges", `${cid}`, "supporter");
        const q = query(supporterRef, orderBy("created", "desc"));
        getDocs(q).then((doc) => {
          doc.docs.forEach((item, index, a_doc) => {
            array.push(item.data().id,);
            if (index == a_doc.length - 1) {
              resolve(array);
            }
          })
        });
      });
      getId.then((array) => {
        let getList = Promise.resolve();
        let usersList = [];
        for (let i = 0; i < array.length; i++) {
          getList = getList.then(getCList.bind(this, array[i]));
        }
        function getCList(id) {
          const challengeRef = doc(db, "users", `${id}`);
          getDoc(challengeRef).then((doc) => {
            usersList.push(doc.data().profile);
            resolve();
          });
        }
        getList.then(() => {
          resolve(usersList);
        });
      })
    });
  },

  // post /////////////////////////////////////////////////////////////////
  setPost(uid, cid, data) {
    return new Promise(resolve => {
      const postRef = collection(db, "challenges", `${cid}`, "posts");
      addDoc(postRef, {
        created: Timestamp.fromDate(new Date()),
        caption: data.caption,
        host: uid,
        images: [],
      }).then((docRef) => {
        upload(cid, docRef.id, data).then((data) => {
          challenge(cid, data).then(() => { resolve(); });
        });
      });
    });
    function upload(cid, pid, data) {
      return new Promise(resolve => {
        let upImages = Promise.resolve();
        let array = [];
        for (let i = 0; i < data.images.length; i++) {
          upImages = upImages.then(upImage.bind(this, cid, pid, i, data.images[i]));
        }
        upImages.then(() => {
          resolve(array);
        });
        function upImage(cid, pid, i, data) {
          return new Promise(resolve => {
            let storageRef = ref(storage, `challenges/${cid}/posts/${pid}/${i}`);
            uploadString(storageRef, data, 'data_url').then(() => {
              getDownloadURL(ref(storage, `challenges/${cid}/posts/${pid}/${i}`)).then((url) => {
                array.push(url);
                const challengeRef = doc(db, "challenges", `${cid}`, "posts", `${pid}`);
                updateDoc(challengeRef, {
                  images: arrayUnion(url),
                }).then(() => {
                  resolve();
                });
              });
            });
          })
        }
      })
    }
    function challenge(cid, data) {
      return new Promise(resolve => {
        const challengeRef = doc(db, "challenges", `${cid}`);
        updateDoc(challengeRef, {
          post: increment(1),
          thumbnail: data[0],
        }).then(() => { resolve(); });
      });
    }
  },
  deletePost(cid, pid) {
    Promise.all([
      post(cid, pid),
      challenge(cid)
    ]);
    function post(cid, pid) {
      return new Promise(resolve => {
        const postRef = doc(db, "challenges", `${cid}`, "posts", `${pid}`);
        deleteDoc(postRef).then(() => { resolve(); });
      });
    }
    function challenge(cid) {
      return new Promise(resolve => {
        const challengeRef = doc(db, "challenges", `${cid}`);
        updateDoc(challengeRef, {
          post: increment(-1),
          thumbnail: '',
        }).then(() => { resolve(); });
      })
    }
  },
  getPost(cid) {
    return new Promise((resolve) => {
      let array = [];
      const postsRef = collection(db, "challenges", `${cid}`, "posts");
      const q = query(postsRef, orderBy("created", "desc"));
      getDocs(q).then((doc) => {
        doc.docs.forEach((item, index, a_doc) => {
          array.push({
            id: item.id,
            created: item.data().created,
            images: item.data().images,
            caption: item.data().caption,
            host: item.data().host,
          });
          if (index == a_doc.length - 1) {
            resolve(array);
          }
        })
      });
    });
  },

  // list ////////////////////////////////////////////////////////////////
  addSubscribe(uid, cid) {
    return Promise.all([
      challenge(uid, cid),
      user(uid, cid),
    ]);
    function challenge(uid, cid) {
      return new Promise((resolve) => {
        const subscriberRef = doc(db, "challenges", `${cid}`, "subscriber", `${uid}`);
        setDoc(subscriberRef, {
          id: uid
        }).then(() => { resolve(); });
      });
    }
    function user(uid, cid) {
      return new Promise((resolve) => {
        const userRef = doc(db, "users", `${uid}`, "subscribe", `${cid}`);
        setDoc(userRef, {
          created: Timestamp.fromDate(new Date()),
          id: cid,
        }).then(() => { resolve(); });
      });
    }
  },
  removeSubscribe(uid, cid) {
    return Promise.all([
      challenge(uid, cid),
      user(uid, cid),
    ]);
    function challenge(uid, cid) {
      return new Promise((resolve) => {
        const subscriberRef = doc(db, "challenges", `${cid}`, "subscriber", `${uid}`);
        deleteDoc(subscriberRef).then(() => { resolve(); });
      });
    }
    function user(uid, cid) {
      return new Promise((resolve) => {
        const userRef = doc(db, "users", `${uid}`, "subscribe", `${cid}`);
        deleteDoc(userRef).then(() => { resolve(); });
      });
    }
  },
  getChallengeSubscriber(cid) {
    //リスト購読者は非公開
    return new Promise((resolve) => {
      let getId = new Promise((resolve) => {
        let array = [];
        const subscriberRef = collection(db, "challenges", `${cid}`, "subscriber");
        const q = query(subscriberRef, orderBy("created", "desc"));
        getDocs(q).then((doc) => {
          doc.docs.forEach((item, index, a_doc) => {
            array.push(item.data().id);
            if (index == a_doc.length - 1) {
              resolve(array);
            }
          })
        });
      });
      getId.then((array) => {
        let getList = Promise.resolve();
        let usersList = [];
        for (let i = 0; i < array.length; i++) {
          getList = getList.then(getCList.bind(this, array[i]));
        }
        function getCList(id) {
          const challengeRef = doc(db, "users", `${id}`);
          getDoc(challengeRef).then((doc) => {
            usersList.push(doc.data().profile);
            resolve();
          });
        }
        getList.then(() => {
          resolve(usersList);
        });
      })
    });
  },
  getSubscribe(uid) {
    return new Promise(resolve => {
      let getId = new Promise(resolve => {
        const userRef = collection(db, "users", `${uid}`, "subscribe");
        const q = query(userRef, orderBy("created", "desc"));
        let id = [];
        getDocs(q).then((doc) => {
          doc.docs.forEach((item, index, arr) => {
            id.push(item.id);
            if (index == arr.length - 1) {
              resolve(id);
            }
          })
        })
      });
      getId.then(array => {
        let getList = Promise.resolve();
        let cheersList = [];
        for (let i = 0; i < array.length; i++) {
          getList = getList.then(getCList.bind(this, array[i]));
        }
        function getCList(id) {
          const challengeRef = doc(db, "challenges", `${id}`);
          getDoc(challengeRef).then((doc) => {
            this.getOtherProfile(doc.data().host).then((data) => {
              cheersList.push({
                id: id,
                data: doc.data(),
                profile: data,
              });
              resolve();
            });
          });
        }
        getList.then(() => {
          store.commit('setCheersList', cheersList);
          resolve();
        });
      });
    });
  },

  // mai ///////////////////////////////////////////////////////////////////
  UserMaiHistory(uid, count, msg) {
    return new Promise(resolve => {
      const docRef = collection(db, "users", `${uid}`, "maiHistory");
      addDoc(docRef, {
        created: Timestamp.fromDate(new Date()),
        count: count,
        msg: msg,
      }).then(() => { resolve(); });
    });
  },
  userMai(uid, change, count) {
    return new Promise(resolve => {
      const docRef = doc(db, "users", `${uid}`);
      switch (change) {
        case 'give':
          updateDoc(docRef, {
            "mai.increment.give": increment(Number(count)),
            "mai.total": increment(Number(count)),
            "mai.useable": increment(Number(count)),
          }).then(() => { resolve(); });
          break;
        case 'buy':
          updateDoc(docRef, {
            "mai.increment.buy": increment(Number(count)),
            "mai.total": increment(Number(count)),
            "mai.useable": increment(Number(count)),
          }).then(() => { resolve(); });
          break;
        case 'assign':
          updateDoc(docRef, {
            "mai.increment.assign": increment(Number(count)),
            "mai.total": increment(Number(count)),
            "mai.useable": increment(Number(count)),
          }).then(() => { resolve(); });
          break;
        case 'send':
          updateDoc(docRef, {
            "mai.decrement.send": increment(Number(count)),
            "mai.total": increment(Number(count)),
            "mai.useable": increment(Number(count) * -1),
          }).then(() => { resolve(); });
          break;
        case 'pay':
          updateDoc(docRef, {
            "mai.decrement.pay": increment(Number(count)),
            "mai.total": increment(Number(count)),
            "mai.useable": increment(Number(count) * -1),
          }).then(() => { resolve(); });
          break;
        default:
          console.log('mai_error');
      }
    });
  },
  challengeMai(uid, cid, count) {
    return Promise.all([
      counter(cid, count),
      supporter(uid, cid, count)
    ]);
    function counter(cid, count) {
      return new Promise(resolve => {
        const docRef = doc(db, "challenges", `${cid}`);
        updateDoc(docRef, {
          mai_support: increment(count),
        }, { marge: true }).then(() => { resolve(); });
      });
    }
    function supporter(uid, cid, count) {
      return new Promise(resolve => {
        const docRef = doc(db, "challenges", `${cid}`, "supporter", `${uid}`);
        setDoc(docRef, {
          id: uid,
          count: increment(count),
        }).then(() => { resolve(); });
      });
    }
  },
  // https://iwb.jp/javascript-timer-click-event/
  // フロント側でクリック間隔が短いときに積算して計上する
  // https://firebase.google.com/docs/firestore/solutions/counters?hl=ja#web_2
  // 分散カウンタ(同じタイミングで書き込みがあった際に分散する)
  // 今回は未実装
  setChallengeMai(uid, name, to_uid, to_name, cid, count) {
    return Promise.all([
      this.UserMaiHistory(uid, count, `${name}を応援したよ`),
      this.UserMaiHistory(to_uid, count, `${to_name}に応援されたよ`),
      this.userMai(uid, 'send', count),
      this.userMai(uid, 'give', count),
      this.challengeMai(uid, cid, count),
    ]);
  },
  setUserMai(uid, change, count) {
    if (change == 'assign') {
      return Promise.all([
        this.UserMaiHistory(uid, count, `運営から${count}maiプレゼントしたよ`),
        this.userMai(uid, 'assign', count),
      ]);
    } else if (change == 'buy') {
      return Promise.all([
        this.UserMaiHistory(uid, count, `${count}mai購入しました`),
        this.userMai(uid, 'buy', count),
      ]);
    } else if (change == 'pay') {
      return Promise.all([
        this.UserMaiHistory(uid, count, `${count}mai使用しました`),
        this.userMai(uid, 'pay', count),
      ]);
    }
  },
  getMai(uid) {
    return new Promise((resolve) => {
      const docRef = doc(db, "users", `${uid}`);
      getDoc(docRef).then((doc) => {
        store.commit('setMai', doc.data().mai);
        // storeに保存
        resolve();
      });
    });
  },
  getMaiHistory(uid) {
    return new Promise(resolve => {
      let array = [];
      const docRef = collection(db, "users", `${uid}`, "maiHistory");
      const q = query(docRef, orderBy("created", "desc"), limit(10));
      getDocs(q).then((doc) => {
        doc.docs.forEach((item, index, a_doc) => {
          array.push({
            id: item.id,
            data: item.data()
          });
          if (index == a_doc.length - 1) {
            resolve(array);
          }
        })
      })
    })
  },

  // Notice /////////////////////////////////////////////////////////////////////////
  setNotice(uid, msg, link, kind) {
    return new Promise(resolve => {
      const NoticeRef = collection(db, "users", `${uid}`, "notice");
      addDoc(NoticeRef, {
        created: Timestamp.fromDate(new Date()),
        message: msg,
        link: link,
        kind: kind,
      }).then(() => {
        resolve();
      });
    });
  },
  getNotice(uid) {
    // https://qiita.com/kyk_nr/items/fb59e237020189dc1c08
    return new Promise(resolve => {
      let array = [];
      const NoticeRef = collection(db, "users", `${uid}`, "notice");
      const q = query(NoticeRef, orderBy("created", "desc"), limit(30));
      getDocs(q).then((doc) => {
        doc.docs.forEach((item, index, a_doc) => {
          array.push({
            id: item.id,
            data: item.data(),
          });
          if (index == a_doc.length - 1) {
            store.commit('setNotice', array);
            resolve();
          }
        })
      });
    });
  },
  getNewPosts() {
    // https://zenn.dev/tentel/articles/35040a2782990c
    return new Promise(resolve => {
      const challengesRef = collection(db, "challenges");
      const q = query(challengesRef, where("data.public", "==", "public"), orderBy("created", "desc"), limit(30));
      getDocs(q).then(doc => {
        let array = [];
        doc.docs.forEach((doc, index, arr) => {
          array.push(doc.data());
          array[index].id = doc.id
          if (index == arr.length - 1) {
            resolve(array);
          }
        });
      })
    });
  },
}
